export enum SubscriptionWorkspaceCapabilityAccessOperation {
    create = "fd0b4dce-bd79-478b-afc6-9e512d7a99db",
    read = "0742f146-050f-42e5-b4e0-306a4e98efc2",
    update = "d5564ba0-8829-444a-a2f5-a21236667015",
    delete = "e310638a-918c-48e4-9d34-455e13db10fb",
}
